//import I18n from "i18n-js/index.js.erb"
import React from "react";

var SeasonBuilderErrors = {

  renderErrors: function (errors) {
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  },

  renderGeneralErrors: function (errors) {
    return this.renderErrors(this.generalErrors(errors));
  },

  renderBillingPolicyErrors: function (errors) {
    return this.renderErrors(this.billingPolicyErrors(errors));
  },

  renderRatesErrors: function (errors) {
    return this.renderErrors(this.ratesErrors(errors));
  },

  billingPolicyErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.billing_policy && errors.billing_policy.length) {
      for (var i = 0, ilen = errors.billing_policy.length; i < ilen; i++) {
        err.push(I18n.t('billing_policy') + ' ' + errors.billing_policy[i]);
      }
    }

    return err;
  },

  generalErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.name && errors.name.length) {
      for (var i = 0, ilen = errors.name.length; i < ilen; i++) {
        err.push(I18n.t('name') + ' ' + errors.name[i]);
      }
    }
    if (errors.code && errors.code.length) {
      for (var i = 0, ilen = errors.code.length; i < ilen; i++) {
        err.push(I18n.t('code') + ' ' + errors.code[i]);
      }
    }
    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    if (errors.start_date && errors.start_date.length) {
      for (var i = 0, ilen = errors.start_date.length; i < ilen; i++) {
      }
    }

    if (errors.end_date && errors.end_date.length) {
      for (var i = 0, ilen = errors.end_date.length; i < ilen; i++) {
        err.push(I18n.t('ends') + ' ' + errors.end_date[i]);
      }
    }

    if (errors.repeats && errors.repeats.length) {
      for (var i = 0, ilen = errors.repeats.length; i < ilen; i++) {
        err.push(I18n.t('repeats') + ' ' + errors.repeats[i]);
      }
    }

    return err;
  },

  roomTypesErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }
    
    if (errors.seasonal_prices) {
      for (var key in errors.seasonal_prices) {
        if (errors.seasonal_prices.hasOwnProperty(key)) {
          var errorObj = {};
          errorObj[key] = errors.seasonal_prices[key];
          err.push(errorObj);
        }
      }
    }
    return err;
  },

  ratesErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.weekly_price && errors.weekly_price.length) {
      for (var i = 0, ilen = errors.weekly_price.length; i < ilen; i++) {
        err.push(I18n.t('weekly_price') + ' ' + errors.weekly_price[i]);
      }
    }

    return err;
  },

};

export default SeasonBuilderErrors
